import { render } from "./FullView.vue?vue&type=template&id=52b3609a&scoped=true"
import script from "./FullView.vue?vue&type=script&lang=js"
export * from "./FullView.vue?vue&type=script&lang=js"

import "./FullView.vue?vue&type=style&index=0&id=52b3609a&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52b3609a"]])

export default __exports__